<template>
<div class="main">
  <div class="component-content">
    <Loading v-if="loading"/>

    <TopMenu class="mb-12p">

      <template v-slot:page-name>销售退单</template>

      <template v-slot:menu-block1>
        <button class="btn btn-blue" :disabled="allowAttack" @click="save()">
          <span class="mr-2">保存</span>
          <img class="icon-16 d-inline-block" src="/static/images/icon/save.svg">
        </button>
        <button class="btn btn-blue ml-2p" :disabled="allowAttack" @click="saveAndPrint()">
          <span class="mr-2">保存并打印</span>
          <img class="icon-16 d-inline-block" src="/static/images/icon/save.svg">
        </button>
      </template>
    </TopMenu>

    <div class="content bg-25 p-2 flex-1">
      <div class="flex-list mb-2">
        <div style="width:50%;">
          <inputSelect v-model="order.customer_id" label="nickname" :options="customer" placeholder="请选择客户" />
        </div>
        
        <div style="width:25%;">
            <DatePicker
            v-model="order.deliver_at"
            :model-config="modelConfig"
            is-dark
            :attributes="attrs"
            :popover="{ visibility: 'click' }"
            @dayclick='dayClicked'
            >
              <template #default="{ inputValue, inputEvents }">
                <input type="text" class="form-control" placeholder="编制日期" :value="inputValue" v-on="inputEvents" >
              </template>
            </DatePicker>
        </div>
        <div style="width:25%;"><input type="text" @change="handleNumber" class="form-control" placeholder="订单号" v-model="order.number"></div>
      </div>

      <div class="d-flex">
        <div class="flex-list-header"></div>
        <div class="flex-list hr w-100">
          <div style="width:30%;padding-left:24px;">产品</div>
          <div style="width:10%;">规格</div>
          <div style="width:10%;">件数</div>
          <div style="width:10%;">数量</div>
          <div style="width:10%;">单价</div>
          <div style="width:20%;">金额</div>
        </div>
      </div>

      <div class="d-flex" v-for="(item, index) in order.list" :key="index">
          <div class="flex-list-header">
            <div class="bg-38">{{ index + 1 }}</div>
            <div class="delete bg-red" @click="deleteRow(index)">-</div>
          </div>
          <div class="flex-list hr w-100">
            <div style="width:30%;padding-left:24px;">
                <inputSelect v-model="order.list[index].product_id" label="name" :options="products" placeholder="请选择产品" inputClass="form-control p-0 bg-none" />
            </div>
            <div style="width:10%;">
              <input type="number" class="form-control p-0 bg-none" placeholder="0" autoComplete="off" v-model="order.list[index].specification">
            </div>
            <div style="width:10%;">
              <input type="number" class="form-control p-0 bg-none" placeholder="0" autoComplete="off" v-model="order.list[index].number" @input="onNumberInput(index)">
            </div>
            <div style="width:10%;">
              <input type="number" class="form-control p-0 bg-none" placeholder="0" autoComplete="off" v-model="order.list[index].quantity" @input="onQuantityInput(index)">
            </div>
            <div style="width:10%;">
              <input type="number" class="form-control p-0 bg-none" placeholder="0.00" autoComplete="off" v-model="order.list[index].price">
            </div>
            <div style="width:20%;">
              {{ formatMoney(item.total, 2) }}
            </div>
          </div>
      </div>
      <button class="btn btn-create p-0" @click="create()">+</button>

      <h2 class="text-slim">总金额<span class="pl-1">￥{{ formatMoney(totalPrice, 2) }}</span></h2>

      <div class="mb-2"><textarea style="resize: none;" class="form-control" placeholder="备注" v-model="order.remarks"></textarea></div>
      <div class="flex-list">
        <div style="width:50%"><input type="text" class="form-control" placeholder="制单人" v-model="order.prepared_by"></div>
        <div style="width:50%"><input type="text" class="form-control" placeholder="送货司机" v-model="order.driver"></div>
      </div>

    </div>

  </div>
</div>
</template>

<script>
import TopMenu from '@/components/TopMenu.vue'
import inputSelect from '@/components/inputSelect.vue'
import { DatePicker } from 'v-calendar';
import formatDate from '@/utils/formatDate.js';

export default {
  name: 'OrderEdit',

  data() {
    return {
      loading: false,
      order: {
        id: null,
        number: null,
        customer_id: null,
        remarks: null,
        deliver_at: formatDate.getNowFormatDay(),
        prepared_by: JSON.parse(sessionStorage.Authorization).nickname,
        driver: null,
        type: 0,
        list:[
          {
            id: null,
            product_id: null,
            name: null,
            specification: null,
            number: null,
            quantity: null,
            price: null,
            total: 0,
          }
        ],
      },
      totalPrice: 0.00,
      products: [],
      customer: [],
      number: null, //修改时保存初始单号
      customerSelect: {
        show: false,
        top: 0,
        left: 0
      },
      allowAttack: false,
      attrs: [
        {
          key: 'today',
          highlight: 'gray',
          dates: new Date(),
        },
      ],
      modelConfig: {
        type: 'string',
        mask: 'YYYY-MM-DD',
      }
    }
  },

  mounted() {
    console.log(this.$options.name+'挂载')

    this.getProductList()
    this.getCustomerList()
    this.getLastNumber(new Date())

    if (this.$route.params.id) {
      this.updateOrder()
      console.log('修改')
    }
  },

  beforeUnmount() {
    console.log(this.$options.name+'销毁完成')
  },

  components: {
    TopMenu,
    inputSelect,
    DatePicker,
  },

  methods: {
    onNumberInput(index) {
      this.order.list[index].quantity = this.$math.Mul(this.order.list[index].number, this.order.list[index].specification)
    },
    onQuantityInput(index) {
      this.order.list[index].number = this.$math.Div(this.order.list[index].quantity, this.order.list[index].specification)
    },


    //获取产品列表
    getProductList(customer) {
      this.$axios.get('/api/product', {
        headers: {
          token: JSON.parse(sessionStorage.Authorization).token
        },
        params: {
          customer: customer
        }
      })
      .then(res => {
        if (res.status == 200) {
          if (res.data) {
            this.products = res.data.product
          }
        }
      })
      .catch(error => {
      console.log('error:', error)
      })
    },

    //获取客户列表
    getCustomerList() {
      this.$axios.get('/api/customer', {
        headers: {
          token: JSON.parse(sessionStorage.Authorization).token
        },
      })
      .then(res => {
        if (res.status == 200) {
          if (res.data) {
            this.customer = res.data.customer
          }
        }
      })
      .catch(error => {
      console.log('error:', error)
      })
    },

    //获取订单单号
    getLastNumber(deliver_at) {
      let _this = this
      return new Promise((resolve, reject) => {
        _this.$axios.post('/api/order/xt-number',
          {
            deliver_at: deliver_at
          },
          {
            headers: {
              token: JSON.parse(sessionStorage.Authorization).token
            }
          }
        )
        .then(res => {
          if (res.status == 200) {
            resolve(res);
            if (res.data) {
              console.log(_this.order.number)
              if (_this.order.number == null) {
                _this.order.number = res.data
                _this.number = res.data
              }
            }
          }
        })
        .catch(error => {
          reject(error)
          console.log('error:', error)
        })
      })
    },

    //更新订单
    updateOrder() {
      this.$axios.get('/api/order/'+this.$route.params.id, {
        headers: {
          token: JSON.parse(sessionStorage.Authorization).token
        },
      })
      .then(res => {
        if (res.status == 200) {
          if (res.data) {
            this.order = res.data
            this.number = res.data.number
          }
        }
      })
      .catch(error => {
      console.log('error:', error)
      })
    },

    // 订单号输入处理
    handleNumber(e) {
      //let _this = this

      if(e.target.value.length > 10){
        this.order.number = e.target.value.slice(0,10)
      } else if(e.target.value.length < 10) {
        this.order.number = this.number
      }

      //传送对比是否重复
      if (this.order.number != this.number) {
        this.$axios.post('/api/order/check-number',
          {
            number: this.order.number
          },
          {
            headers: {
              token: JSON.parse(sessionStorage.Authorization).token
            }
          }
        )
        .then(res => {
          if (res.status == 200) {
            if (res.data.success) {
              this.$toast.success(res.data.message)
            } else {
              this.$toast.error(res.data.message)
              this.order.number = this.number
            }
          }
        })
        .catch(error => {
        console.log('error:', error)
        })
      }

    },

    dayClicked() {
      console.log(this.order.deliver_at)

      // 对比月份是否有改变
      let deliver_at = new Date(this.order.deliver_at);
      let nowMonth = new Date();
      if (deliver_at.getMonth() == nowMonth.getMonth()) {
        // 如果是修改订单
        if (this.number) {
          this.order.number = this.number
        }
      } else {
        let _this = this
        this.getLastNumber(this.order.deliver_at).then(res => {
          _this.order.number = res.data
        })
      }
    },

    create() {
      this.order.list.push({
        id: null,
        product_id: null,
        name: null,
        specification: null,
        number: null,
        quantity: null,
        price: null,
        total: 0,
      })
    },

    deleteRow(index) {
      if (this.order.list.length > 1) {
        this.order.list.splice(index, 1)
      }
    },

    destroy() {
      this.$router.push({name: 'OrderList'})
    },

    save() {
      let _this = this
      this.allowAttack = true
      return new Promise((resolve, reject) => {
        try {
          if (this.order.number==null) throw '请填写单号'
          if (this.order.customer_id==null) throw '请选择客户名称'
          if (this.order.deliver_at==null) throw '请选择发货日期'

          // 正则验证是否填写数字
          let reg = /^[0-9]+.?[0-9]*/;
          this.order.list.forEach(function(item) {
            if (!reg.test(item.product_id) || !reg.test(item.specification) || !reg.test(item.number) || !reg.test(item.quantity) || !reg.test(item.price)) throw '请填写必要的信息'
          })

          
          _this.$axios.post('/api/order/save',
            {
              order: _this.order
            },
            {
              headers: {
                token: JSON.parse(sessionStorage.Authorization).token
              }
            }
          )
          .then(res => {
            _this.allowAttack = false

            if (res.status == 200) {
              resolve(res);
              console.log(res.data)
              if (res.data.success) {
                res.data.data.list.forEach(function(item) {
                  item.number = _this.$math.Div(item.quantity, item.specification)
                })
                this.order = res.data.data
                this.$toast.success(res.data.message)
              } else {
                this.$toast.error(res.data.message)
              }
              
            }
          })
          .catch(error => {
            reject(error)
            _this.allowAttack = false
            console.error('error:', error)
          })
         
        } catch(error) {
          console.error(error)
          _this.allowAttack = false
          this.$toast.error(error)
        }
      })
    },

    saveAndPrint() {
      this.save().then(res => {
        if (res.data.success) {
          this.$router.push({name: 'OrderPrint', params: {id: res.data.data.id}})
        }
      })
    },
  },

  watch: {
    'order.customer_id': function() {
      this.getProductList(this.order.customer_id)
    },

    orderDatas: {
      handler: function(val, oldVal) {
        let _this = this
        let value = JSON.parse(val)
        let oldValue = JSON.parse(oldVal)
        let rowPrice = []
        let totalPrice = 0

        for (let i = 0; i < value.length; i++) {
          if (value[i] != oldValue[i]) {
              //更新产品规格
              if (oldValue[i]) {
                if (value[i].product_id != oldValue[i].product_id) {
                  for (let t = 0; t < this.products.length; t++) {
                    if (this.products[t].id == this.order.list[i].product_id) {
                      this.order.list[i].specification = this.products[t].specification
                      // 自动填充默认单价
                      if (!this.order.list[i].price) {
                        this.order.list[i].price = this.products[t].price
                      }
                      
                    }
                  }
                }

                if (value[i].specification != oldValue[i].specification) {
                  this.order.list[i].number = this.$math.Div(this.order.list[i].quantity, this.order.list[i].specification)
                }
                
              } else {
                for (let t = 0; t < this.products.length; t++) {
                  if (this.products[t].id == this.order.list[i].product_id) {
                    this.order.list[i].specification = this.products[t].specification
                  }
                }

                if (value[i].specification) {
                  this.order.list[i].number = this.$math.Div(this.order.list[i].quantity, this.order.list[i].specification)
                }
              }

              // 计算单行总价
              this.order.list[i].total = this.$math.Mul(this.order.list[i].quantity, this.order.list[i].price)

              if (!isNaN(this.order.list[i].total)) {
                rowPrice[i] = this.order.list[i].total
              }
          }
        }

        // 计算所有总价
        rowPrice.forEach(function(item) {
          totalPrice = _this.$math.Add(totalPrice, item)
        })
        this.totalPrice = totalPrice
        
      },
      deep: true
    }
  },

  computed: {
    formatMoney() {
      /**
       * @description 格式化金额
       * @param number：要格式化的数字
       * @param decimals：保留几位小数 默认0位
       * @param decPoint：小数点符号 默认.
       * @param thousandsSep：千分位符号 默认为,
       */
      return (number, decimals = 0, decPoint = '.', thousandsSep = ',') => {
        return this.$math.formatMoney(number, decimals, decPoint, thousandsSep)
      }
    },

    orderDatas() {
      return JSON.stringify(this.order.list)
    }

  }
}

</script>

<style lang="scss" scoped>

.flex-list-header .delete {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.flex-list-header:hover .delete {
  display: block;
}
.btn-create {
  width: 40px;
  height: 40px;
  color: #fff;
  text-align: center;
  line-height: 40px;
  padding: 0;
  flex-shrink: 0;
  background-color: #004bff;
}

::v-deep .vc-container.vc-is-dark {
  color: #fff;
  background-color: #383838;
  border: none;
}
 
</style>
